import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {URL} from '../../Config/appConfig';
import {Auth, Option} from '../../Config/dataModel';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import util from '../../Util/util';

const logo = require('../../resource/img/logo.svg');

interface SelectInsurerProps {
    auth: () => Auth,
    setSelectedInsurer: (insurer: Option) => void
}

class SelectInsurer extends React.Component <RouteComponentProps & SelectInsurerProps, {}> {
    public clickOption(value: string, label: string) {
        this.props.setSelectedInsurer(util.getCompany(value, label));
        this.props.history.push(URL.DASHBOARD);
    }

    public getInsurerOptions() {
        const options = [];
        for (const item in this.props.auth().registeredCounterparties) {
            const data = this.props.auth().registeredCounterparties[item];
            options.push(
                <button key={item} className="cmText insurerOption" onClick={(e) => this.clickOption(data.x500Name, data.company)}>{data.company}</button>
            );
        }
        return options;
    }

    public render() {
        return (
            <div className="cmCenter loginContainer">
                <img className="cmHorCenter cmClickable" src={logo}/>
                <div className="cmText loginLabel insurerSelectionLabel">Select one insurer to login</div>
                {this.getInsurerOptions()}
            </div>
        );
    }
}

export default withRouter(connect(authState, authDispatch)(SelectInsurer));



// WEBPACK FOOTER //
// ./src/Components/Auth/SelectInsurer.tsx